export function falseNotZero(value) {
    return !value && value !== 0;
}
const IS_FLOAT_REGEX = /^\d*(\.\d?\d?)?$/; // matches the following (d for any digit): 'd', 'd.','d.d', 'd.dd'
const IS_NEGATIVE_FLOAT_REGEX = /^-?\d*(\.\d?\d?)?$/; // the same, with an optional leading minus

export function getFloatRegex(allowNegative: boolean) {
    return allowNegative ? IS_NEGATIVE_FLOAT_REGEX : IS_FLOAT_REGEX;
}

export const ALLOWED_SPECIAL_KEYS_ON_INPUT = [
    'Delete',
    'Backspace',
    'ArrowRight',
    'Meta',
    'Tab',
    'ArrowLeft'
];

export function isNonNumberKey(
    e: React.KeyboardEvent<HTMLInputElement>,
    ctrlOn: boolean,
    allowNegative = false
) {
    // allow numbers and clipboard shortcuts
    return !(
        getFloatRegex(allowNegative).test(e.key) ||
        (ctrlOn && ALLOWED_CLIPBOARD_CHARS.includes(e.key))
    );
}

export function isSecondDot(e: React.KeyboardEvent<HTMLInputElement>) {
    return e.key === '.' && e.currentTarget.value?.includes('.');
}

/** A minus is valid only as the first character, and only once. */
export function acceptsMinusAtCaret(input: HTMLInputElement) {
    const { value, selectionStart, selectionEnd } = input;
    // no caret info on type="number"
    if (selectionStart === null) {
        return true;
    }
    const survivingValue =
        value.slice(0, selectionStart) +
        value.slice(selectionEnd ?? selectionStart);
    return selectionStart === 0 && !survivingValue.includes('-');
}

export function isSecondMinus(e: React.KeyboardEvent<HTMLInputElement>) {
    return e.key === '-' && !acceptsMinusAtCaret(e.currentTarget);
}

const ALLOWED_CLIPBOARD_CHARS = ['v', 'c', 'a', 'x'];

export type HBMoneySizes = 'sm' | 'md' | 'lg';

export const HBMONEY_INPUT_PADDING: Record<
    HBMoneySizes,
    { paddingLeft: string }
> = {
    sm: {
        paddingLeft: '30px'
    },
    md: {
        paddingLeft: '12px'
    },
    lg: {
        paddingLeft: '56px'
    }
};
